<template>
    <div class="">
        <dl>
            <dt>ID:</dt>
            <dd>{{ user.id }}</dd>
        </dl>
        <dl>
            <dt>Name:</dt>
            <dd>{{ user.userName }}</dd>
        </dl>
        <dl>
            <dt>E-mail:</dt>
            <dd>{{ user.email }}</dd>
        </dl>
        <dl>
            <dt>Reg. date:</dt>
            <dd>{{ dateFormat(user.date_created) }}</dd>
        </dl>
        <dl>
            <dt>Role:</dt>
            <dd :class="{'color-green' : (user.role === 'admin')}">{{ user.role }}</dd>
        </dl>
        <dl>
            <dt>Status:</dt>
            <dd :class="{'color-red' : !user.active}">{{ userStatus }}</dd>
        </dl>
    </div>
</template>

<script>
    export default {
        name: "UserInfo",

        props: [
            'user',
        ],

        computed: {
            userStatus() {
                return this.user.active ? 'active' : 'banned';
            },

        },

        methods: {
            dateFormat(date) {
                return date?.slice(0,10);
            },

        },

    }
</script>

<style scoped>
    dl {
        display: flex;
    }

    dt {
        width: 80px;
        font-weight: 700;
    }
</style>